import {
  type GetSearchLinkResultsArgs,
  useInfiniteScrollFromCache,
  useLazyGetDemoSearchLinksResultsQuery,
} from '@carboncopyco/data';
import type { DemoShare } from '@carboncopyco/types';
import type { DropdownFilterItemContent } from '@carboncopyco/ui';
import { useEffect, useMemo, useState } from 'react';
import { SessionsBreakdownFilter } from './SessionsBreakdownFilter';

type LinkNamesFilterProps = {
  organizationId: string;
  demoId: string;
  workspaceId: string;
};

export const DemoLinkFilter = ({
  organizationId,
  demoId,
  workspaceId,
}: LinkNamesFilterProps) => {
  const [query, setQuery] = useState('');

  const fetchArgs: GetSearchLinkResultsArgs = useMemo(
    () => ({
      organizationId,
      workspaces: [workspaceId],
      id: demoId,
      query,
    }),
    [organizationId, workspaceId, demoId, query]
  );

  const {
    items,
    isLoading,
    isLoadingBatch,
    fetchFirstBatch,
    fetchNextBatch,
    isEmpty,
  } = useInfiniteScrollFromCache<DemoShare, GetSearchLinkResultsArgs>(
    useLazyGetDemoSearchLinksResultsQuery,
    fetchArgs
  );

  useEffect(() => {
    fetchFirstBatch();
  }, [fetchArgs, fetchFirstBatch]);

  const options: DropdownFilterItemContent<string>[] =
    items?.map((item) => ({
      ...item,
      id: String(item.id),
      label: item.options.linkDescription,
    })) ?? [];

  return (
    <SessionsBreakdownFilter
      type="links"
      placeholder="Link Name"
      options={options}
      query={query}
      setQuery={setQuery}
      onInputChange={fetchFirstBatch}
      fetchNextBatch={fetchNextBatch}
      isLoading={isLoading}
      isLoadingBatch={isLoadingBatch}
      disabled={isEmpty}
    />
  );
};
